import { Injectable, Inject } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import { DEFAULT_PAGE_SIZE } from '../../constants/commonConstants';
import { ENV_CONFIG } from 'src/app/core/injection.token';

type DynamicResponse<T> = app.models.DynamicResponse<T>;
type DynamicPaged<T> = app.models.DynamicResponse<app.models.PagedResult<T>>;

@Injectable()
export class InsuranceAPIService {
  public constructor(
    @Inject(ApiService) private _apiService: ApiService,
    @Inject(ENV_CONFIG) private _envConfig: env.EnvData
  ) {}

  private readonly controller = 'insurance';

  public getPagedInsurances(pageIndex: number, pageFilter: app.models.GetPagedInsurancesFilterModel) {
    let data = {
      startDate: pageFilter.startDate ? pageFilter.startDate.toISOString() : null,
      endDate: pageFilter.endDate ? pageFilter.endDate.toISOString() : null,
      page: pageIndex,
      size: DEFAULT_PAGE_SIZE,
    };
    const request = 'getPagedInsurances';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request, data);
    return this._apiService.get<DynamicPaged<app.models.InsuranceModel>>(url);
  }

  public getInsurance(insuranceId: string) {
    const request = 'getInsurance';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request, {
      insuranceId: insuranceId,
    });
    return this._apiService.get<DynamicResponse<app.models.GetInsuranceModel>>(url);
  }

  public getInsurancePaymentSchedule(insuranceId: string) {
    const request = 'getInsurancePaymentSchedule';
    const url = this._apiService.buildUrl(this._envConfig.PORTAL_BACKEND_APISYNC_URL, this.controller, request, {
      insuranceId: insuranceId,
    });
    return this._apiService.get<DynamicResponse<app.models.GetInsurancePaymentScheduleModel[]>>(url);
  }
}
